import { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { ROLES, PORTAL_ROLES, projectPath } from "@/lib/roles";
import Navbar from "@/components/Navbar";
import ProjectCard from "@/components/ProjectCard";
import LoadingScreen from "@/components/LoadingScreen";
import NoAccess from "@/pages/NoAccess";

export default function PortalHome() {
  const { role } = useParams();
  const valid = PORTAL_ROLES.includes(role);
  const [projects, setProjects] = useState(null);

  useEffect(() => {
    if (!valid) return;
    api.get("/projects", { params: { role } })
      .then((r) => setProjects(r.data))
      .catch(() => toast.error("No se han podido cargar tus proyectos."));
  }, [role, valid]);

  if (!valid) return <Navigate to="/" replace />;
  if (!projects) return <LoadingScreen text="Abriendo tu portal…" />;
  if (projects.length === 0) return <NoAccess title={`No tienes proyectos como ${ROLES[role].label.toLowerCase()}`} />;
  if (projects.length === 1) return <Navigate to={projectPath(role, projects[0].project_id)} replace />;

  return (
    <div className="min-h-screen bg-background" data-testid="portal-home">
      <Navbar roleLabel={ROLES[role].label} />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="caption mb-2">Portal de {ROLES[role].label.toLowerCase()}</div>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight mb-8">Tus proyectos</h1>
        <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-5">
          {projects.map((p, i) => <ProjectCard key={p.project_id} project={p} index={i} />)}
        </div>
      </main>
    </div>
  );
}
